(function($) {
    $(function() {
      
             var userFeed = new Instafeed({
         get: 'user',
         userId: parseInt($("#hdnuserid").val()),
         accessToken: $("#hdnusertoken").val(),
         //userId: 29974033,
          //limit: parseInt($("#hdnlimit").val()),
         //accessToken: '29974033.467ede5.52c0048c27bf40c3a901b5b64af1b18c',
         resolution: 'low_resolution',      
            
        template: '<a target="_blank" href="{{link}}"><img alt="{{caption}}" src="{{image}}" /></a>',
               
               after: 
               
        function() {   
               
               
var myEls  = $('#instafeed > a');
var numEls = myEls.length;

for ( i=0; i<numEls; i=i+2) {
  myEls.eq(i)
    .add( myEls.eq(i+1) )
    .wrapAll('<li />');
	//.wrapAll('<div class="col-sm-2"></div>')
    //.wrapAll('<div class="insta_follower_img"></div>');
}        
               
               
        var jcarousel = $('.jcarousel');

        jcarousel
            .on('jcarousel:reload jcarousel:create', function () {
                var width = jcarousel.innerWidth();

                 if (width >= 621) {
					 width = width / 6;
					  $('.jcarousel-wrapper .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=2'
            });

        $('.jcarousel-wrapper .jcarousel-control-next')
            .jcarouselControl({
                target: '+=2'
            }); 
		
				 }
                else if (width >= 600) {
                    width = width / 6;
					  $('.jcarousel-wrapper .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=2'
            });

        $('.jcarousel-wrapper .jcarousel-control-next')
            .jcarouselControl({
                target: '+=2'
            });
			 $('.jcarousel-wrapper .jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .on('click', function(e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 1,
                item: function(page) {
                    return '<a href="#' + page + '">' + page + '</a>';
                }
            });
                } else if (width >= 350) {
                    width = width / 2;
					  $('.jcarousel-wrapper .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=2'
            });

        $('.jcarousel-wrapper .jcarousel-control-next')
            .jcarouselControl({
                target: '+=2'
            });
                }

                jcarousel.jcarousel('items').css('width', width + 'px');
            })
            .jcarousel({
                wrap: 'circular'
            });

        $('.jcarousel-wrapper .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=2'
            });

        $('.jcarousel-wrapper .jcarousel-control-next')
            .jcarouselControl({
                target: '+=2'
            });
			
	    $('.jcarousel').jcarouselAutoscroll({
    target: '+=2'
});
$('.jcarousel').jcarouselAutoscroll('reload', {
    interval: 4500
});


/*jcarousel.touchwipe({
  wipeLeft: function() {
    jcarousel.jcarousel('scroll', '+=1');
  },
  wipeRight: function() {
    jcarousel.jcarousel('scroll', '-=1');
  },
  min_move_x: 20,
  min_move_y: 20,
  preventDefaultEvents: false
});*/

        
		 $('.jcarousel').hover(function() {
			$('.jcarousel').jcarouselAutoscroll('stop'); 
		 }, function() {
			 $('.jcarousel').jcarouselAutoscroll('start');
		 });


        $('.jcarousel-wrapper .jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .on('click', function(e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 12,
                item: function(page) {
                    return '<a href="#' + page + '">' + page + '</a>';
                }
            });
             
        
        }        
    });
    userFeed.run();
      

      
     
    });
})(jQuery);
